// Definir los campos comunes
const commonFields = {
    AR: [
        {
            name: 'Razón social',
            key: 'company_name',
            placeholder: 'Ingresa la razón social',
        },
        {
            name: 'CUIT',
            key: 'tax_id',
            placeholder: 'Ingresa el CUIT',
        },
    ],
    MX: [
        {
            name: 'Razón social',
            key: 'company_name',
            placeholder: 'Ingresa la razón social',
        },
        {
            name: 'RFC',
            key: 'tax_id',
            placeholder: 'Ingresa el RFC',
        },
    ],
    CO: [
        {
            name: 'Razón social',
            key: 'company_name',
            placeholder: 'Ingresa la razón social',
        },
        {
            name: 'NIT',
            key: 'tax_id',
            placeholder: 'Ingresa el NIT',
        },
    ],
    BR: [
        {
            name: 'Razão Social',
            key: 'company_name',
            placeholder: 'Digite o nome da empresa',
        },
        {
            name: 'CNPJ',
            key: 'tax_id',
            placeholder: 'informe no CNPJ',
        },
    ],
    US: [
        {
            name: 'Company name',
            key: 'company_name',
            placeholder: 'Enter Company name',
        },
        {
            name: 'EIN',
            key: 'tax_id',
            placeholder: 'Enter EIN',
        },
    ],
    ES: [
        {
            name: 'Razón social',
            key: 'company_name',
            placeholder: 'Ingresa la Razón social',
        },
        {
            name: 'NIF',
            key: 'tax_id',
            placeholder: 'Ingresa el NIF',
        },
    ],
};

// const filesByCountry = {
//     AR: [
//         {
//             name: 'Constancia de CUIT',
//             key: 'const_cuil',
//             placeholder: 'Seleccionar archivo',
//         },
//         {
//             name: 'Constancia de IIBB',
//             key: 'const_iibb',
//             placeholder: 'Seleccionar archivo',
//         },
//         {
//             name: 'Dispone',
//             key: 'dispone',
//             placeholder: 'Seleccionar archivo',
//         },
//         {
//             name: 'Código GLN',
//             key: 'gln',
//             placeholder: 'Ej: 1234567890123',
//         },
//     ],
//     MX: [
//         {
//             name: 'Copia del acta constitutiva',
//             key: 'Copia del acta constitutiva',
//             placeholder: 'Seleccionar archivo',
//         },
//         {
//             name: 'Constancia de situación fiscal',
//             key: 'Constancia de situación fiscal',
//             placeholder: 'Seleccionar archivo',
//         },
//         {
//             name: 'Copia del INE',
//             key: 'Copia del INE',
//             placeholder: 'Seleccionar archivo',
//         },
//         {
//             name: 'Aviso de funcionamiento de COFEPRIS',
//             key: 'Aviso de funcionamiento de COFEPRIS',
//             placeholder: 'Seleccionar archivo',
//         },
//         {
//             name: 'Comprobante de domicilio',
//             key: 'Comprobante de domicilio',
//             placeholder: 'Seleccionar archivo',
//         },
//     ],
// };

// Función para obtener los archivos y campos dinámicamente
export const getFieldsByCountry = (country) => {
    const FIELDS = commonFields[country] || [];
    return { FIELDS };
};

export enum DocsTypes {
    'Constancia de CUIT' = 1,
    'Constancia de IIBB' = 2,
    'Dispone' = 3,
    'Código GLN' = 4,
    'Copia del acta constitutiva' = 5,
    'Constancia de situación fiscal' = 6,
    'Copia del INE' = 7,
    'Aviso de funcionamiento de COFEPRIS' = 8,
    'Comprobante de domicilio' = 9,
}
